<template>
    <div class="ressource-error-container">
        <v-card class="ressource-error-card" elevation="0">
            <v-card-text class="text-center pa-8 pa-md-12">
                <div class="error-illustration mb-8">
                    <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="100" cy="100" r="80" fill="#FEE" stroke="#F44336" stroke-width="2"/>
                        <path d="M70 70L130 130M130 70L70 130" stroke="#F44336" stroke-width="8" stroke-linecap="round"/>
                    </svg>
                </div>
                
                <h1 class="text-h4 font-weight-bold mb-4 error-title">
                    {{ $translate("errorTitle") }}
                </h1>
                
                <p class="text-body-1 mb-4 grey--text text--darken-1">
                    {{ $translate("errorLoadingResourceMessage") }}
                </p>
                
                <v-alert
                    v-if="error && error.message"
                    type="error"
                    outlined
                    class="mt-6 mb-6"
                    text
                >
                    <div class="text-left">
                        <div class="font-weight-bold mb-2">{{ $translate("technicalDetails") }}:</div>
                        <div class="text-caption">{{ error.message }}</div>
                        <div v-if="error.code" class="text-caption mt-1">
                            {{ $translate("errorCode") }}: {{ error.code }}
                        </div>
                    </div>
                </v-alert>
                
                <p class="text-body-2 mb-2 grey--text">
                    {{ $translate("contactAdministratorMessage") }}
                </p>
                <div class="mb-8">
                    <p class="text-body-2 mb-2 d-flex align-center justify-center">
                        <v-icon small class="mr-2">mdi-email</v-icon>
                        <a href="mailto:support@safetee.io" class="support-link">support@safetee.io</a>
                    </p>
                    <p class="text-body-2 mb-0 d-flex align-center justify-center">
                        <v-icon small class="mr-2">mdi-phone</v-icon>
                        <a href="tel:+33972195305" class="support-link">+33 9 72 19 53 05</a>
                    </p>
                </div>
                
                <div class="d-block d-sm-flex justify-center flex-wrap ga-4">
                    <v-btn
                        color="grey"
                        class="w-100 w-sm-auto"
                        outlined
                        @click="$router.go(-1)"
                    >
                        <v-icon left small>mdi-arrow-left</v-icon>
                        {{ $translate('back') }}
                    </v-btn>
                    <v-btn
                        color="primary"
                        class="mt-4 mt-sm-0 ml-sm-6 w-100 w-sm-auto"
                        @click="$router.push({ name: 'dashboard' })"
                    >
                        <v-icon left small>mdi-home</v-icon>
                        {{ $translate('goToHome') }}
                    </v-btn>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    props: {
        error: {
            type: Object,
            default: null,
        },
    },
    i18n: {
        messages: {
            en: {
                errorTitle: "An error occurred",
                errorLoadingResourceMessage: "An error occurred while loading this resource.",
                contactAdministratorMessage: "If this problem persists, please contact your administrator.",
                technicalDetails: "Technical details",
                errorCode: "Error code",
                back: "Back",
                goToHome: "Go to home",
            },
            fr: {
                errorTitle: "Une erreur est survenue",
                errorLoadingResourceMessage: "Une erreur est survenue pendant le chargement de cette ressource.",
                contactAdministratorMessage: "Si ce problème persiste, veuillez contacter votre administrateur.",
                technicalDetails: "Détails techniques",
                errorCode: "Code d'erreur",
                back: "Retour",
                goToHome: "Retour à l'accueil",
            },
        },
    },
};
</script>

<style scoped>
.ressource-error-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
    padding: 0px;
}

.ressource-error-card {
    max-width: 600px;
    width: 100%;
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.error-illustration {
    display: flex;
    justify-content: center;
    align-items: center;
}

.error-title {
    color: #f44336;
}

.support-link {
    color: #1976d2;
    text-decoration: none;
    font-weight: 500;
}

.support-link:hover {
    text-decoration: underline;
}
</style>
